/* !
 * jQuery shops v1.0.0
 * Copyright 2017, Connecty Inc.
 */
(function($, NSKW, cssua){
	const a = 'is-active';
	const v = 'is-visible';
	const navText = [
		'<i class="icon icon-arrow_left"></i>',
		'<i class="icon icon-arrow_right"></i>'
	];
	let site = 'cp', shopID;
	if (location.pathname.indexOf('nishikawa-chain') !== -1) { site = 'chain'; }
	else if (location.pathname.indexOf('/sme/') !== -1) { site = 'sme'; }

	if (site !== 'sme') {
		if (site === 'chain') {
			shopID = location.pathname.split('/')[5];
		} else {
			shopID = location.pathname.split('/')[3];
		}
	}
	let param = location.search;

	// ＜店舗検索＞地域選択
	const searchSelectPref = (_url2) => {
		let $prefSelect = $('.js-prefSelect');
		// 検索時に指定した地域を選択状態にする
		$('.shops-search-pref .mod-check-input').each((idx, ele) => {
			if ($(ele).prop('checked')) {
				$(ele).parents('.js-prefSelect-content').addClass(a).addClass(v);
				let targetArea = $(ele).parents('.js-prefSelect-content').attr('data-target');
				$('option', $prefSelect).each((idx2, ele2) => {
					if ($(ele2).attr('data-switch') === targetArea) {
						$(ele2).attr('selected', 'selected');
					}
				});
			}
		});
		$prefSelect.change((e) => {
			// チェックを全て外す
			$('.shops-search-pref .mod-check-input').each((idx, ele) => {
				$(ele).prop('checked', false);
			});
			$(e.currentTarget).parents('.shops-search-pref').find('.js-prefSelect-content').each((idx, ele) => {
				$(ele).removeClass(a).removeClass(v);
			});

			let target = $(e.currentTarget).find('option:selected').attr('data-switch');
			let $switch = $(e.currentTarget).parents('.shops-search-pref').find('[data-target=' + target + ']');

			$switch.addClass(a);
			setTimeout(() => {
				$switch.addClass(v);
			}, '200');
		});

		// 都道府県を選択状態にする
		if (_url2) {
			if (_url2.indexOf('.html') === -1 && _url2 !== '') {
				$('select*[name=pref] option').each((edx, ele) => {
					if ($(ele).attr('data-target') === _url2) {
						$(ele).attr('selected', 'selected');
					}
				});
			}
		}
	};

	// ＜店舗検索＞解説チップ表示
	const searchSetTip = () => {
		$('.mod-search-tip-btn').on('click', (e) => {
			$(e.currentTarget).next('.mod-search-tip-content').toggleClass(a);
		});
		$('.mod-search-tip-content .icon-close').on('click', (e) => {
			e.stopPropagation();
			$(e.currentTarget).parents('.mod-search-tip-content').removeClass(a);
		});
	};

	// ＜店舗検索＞取り扱いブランド
	const searchSetBrands = () => {
		let $brandList = $('.brandList1 + ul .rt_jbn_product_brand_list');
		$brandList.each((idx, ele) => {
			let brandId = $(ele).children('.rt_cf_pb_id').text();
			let brandName = $(ele).children('.rt_cf_pb_name_d').text();
			idx++;
			let iLen = String(idx).length;
			if (iLen === 1) {
				idx = '0' + idx;
			}
			let brandOp = '<option id="brand' + idx + '" value="' + brandId + '">' + brandName + '</option>',
				brandOp2 = '<option id="brand' + idx + '_2" value="' + brandId + '">' + brandName + '</option>';
			$('.brandList1 label select').append(brandOp);
			$('.brandList2 label select').append(brandOp2);
		});

		// 検索時に指定したブランドを選択状態にする
		if (param) {
			param = param.substring(1);
			var paramUrl = param.split('&');
			var paramBrand;
			$.each(paramUrl, (idx, val) => {
				if (val.indexOf('handled_brand') !== -1) {
					paramBrand = val.split('=')[1];
				}
			});
			$('option', $('select[name="handled_brand"]')).each((idx, ele) => {
				if ($(ele).val() === paramBrand) {
					$(ele).attr('selected', 'selected');
				}
			});
		}
	}

	// ＜店舗検索＞クリアボタン
	const searchClear = () => {
		$('.mod-search-box .mod-search-submit-clear').on('click', () => {
			$('.mod-search-box .mod-input').each((idx, ele) => {
				$(ele).val('');
			});
			$('.mod-search-box .mod-check-input').each((idx, ele) => {
				$(ele).prop('checked', false);
			});
			$('.mod-search-box .mod-select select').each((idx, ele) => {
				$(ele).val('');
			});
			$('.js-prefSelect-content').each((idx, ele) => {
				$(ele).removeClass(a).removeClass(v);
			});
		});
	};

	// ＜店舗検索：submit処理（複数キーワード分割）＞
	const searchSubmit = (_$form) => {
		if(_$form.length > 0) {
			let hiddenKeyword = '';
			const keywords = _$form.find('.mod-input[name=keyword]').val().trim().split(/[\s\u3000]+/);
			keywords.forEach((ele, index) => {
				hiddenKeyword += `<input type="hidden" name="keyword${index+1}" value="${ele}">`;
			});
			_$form.append(hiddenKeyword);
			_$form.submit();
		} else {
			let params = new URLSearchParams(location.search);
			params.delete('keyword');
			params.delete('pref');
			for (let i = 1; i <= 10; i++) {
				params.delete(`keyword${i}`);
			}
			let keywords = $('.shops-search-addition .mod-input[name=keyword]').val().trim().split(/[\s\u3000]+/);
			// console.log(keywords,'keywords');
			let pref = $('.shops-search-addition .mod-select select[name=pref] option:selected').val();
			if(keywords !== '') {
				let keywordinput = '';
				keywords.forEach((ele, index) => {
					keywordinput += ele + ' ';
					let setkeyword = `keyword${index+1}`;
					params.set(setkeyword, ele);
				});
				params.set('keyword', keywordinput);
			}
			if(pref !== '') {
				params.set('pref', pref);
			}
			const newUrl = `${location.pathname}?${params.toString()}`;
			location.href = newUrl;
		}
	};

	// ＜店舗検索＞検索結果並び替え
	const searchResultSort = (_url2) => {
		let $href,
			$selectSort = $('.js-selectViewSort'),
			shopsPass = '/shops/',
			smePass = '/sme/',
			chainPass = '/contents/nishikawa-chain/shops/';

		if ($selectSort.length > 0) {
			if (site === 'chain') {
				$href = chainPass; // 西川チェーン
			} else if (site === 'sme') {
				$href = smePass; // スリープマスターエキスパート
			} else {
				$href = shopsPass; // 通常の販売店
			}

			if (site !== 'sme') {
				if (param != '') {
					// パラメータがある場合
					$selectSort.on('change', (e) => {
						$href += $(e.currentTarget).val() + '.html?' + param;
						location.href = $href;
					});
				} else {
					// 各都道府県の店舗一覧の場合
					$selectSort.on('change', (e) => {
						let thisPref = $('select*[name=pref] option:selected').val();
						$href += $(e.currentTarget).val() + '.html' + '?shop_style=&keyword=&pref=' + thisPref + '&service=&adviser=&handled_brand=&shop_brand=';
						location.href = $href;
					});
				}
			} else {
				// スリープマスターエキスパートの場合
				$selectSort.on('change', (e) => {
					let thisPref = NSKW.va.pathname.split('/')[2];
					let thisSort = $(e.currentTarget).val() === 'search' ? '' : 'zipcode.html';
					$href += thisPref + '/' + thisSort;
					location.href = $href;
				});
			}

			// 並び替えプルダウンのカレント
			let thisSort;
			if (NSKW.va.pathname.indexOf('zipcode') !== -1) {
				thisSort = 'zipcode';
			} else {
				thisSort = 'search';
			}
			$selectSort.val(thisSort);

			// ソートによってフォームのaction変更
			let sortOption = $('.js-selectViewSort option:selected').val();
			if (site === 'chain') {
				$('form').attr('action', chainPass + sortOption + '.html'); // 西川チェーン
			} else {
				$('form').attr('action', shopsPass + sortOption + '.html'); // 通常の販売店
			}
		} else {
			if (_url2 === 'zipcode.html') {
				//検索結果が0件でzipcode.htmlの場合
				if (site === 'chain') {
					$('form').attr('action', chainPass + _url2); // 西川チェーン
				} else {
					$('form').attr('action', shopsPass + _url2); // 通常の販売店
				}
			}
		}
	}

	// ＜店舗検索＞絞り込み条件を表示
	const searchNarrowDown = () => {
		if ($('.paramsList').length > 0) {
			$('.inc_shops_search1 .mod-search-body').each((idx, ele) => {
				let paramName = $(ele).children('.mod-search-body-head').find('.__name').text(),
					paramVlaue;

				if (paramName === 'キーワード') {
					paramVlaue = $(ele).children('.mod-search-block01').children('input').val();
				}
				if (paramName === '都道府県') {
					paramVlaue = $('[name=pref] option:selected').val();
				}
				if (paramName === '取り扱いブランド') {
					paramVlaue = $('.inc_shops_search1 [name=handled_brand] option:selected').text();
				}
				if (paramName === 'ショップ＆コーナー') {
					paramVlaue = $('.inc_shops_search1 [name=shop_brand] option:selected').text();
				}
				if (paramName === 'サービス・特徴' || paramName === '資格・アドバイザー') {
					let arr = [],
						elements;
					if (paramName === 'サービス・特徴') {
						elements = document.querySelectorAll('.inc_shops_search1 input[name=service]:checked');
					}
					if (paramName === '資格・アドバイザー') {
						elements = document.querySelectorAll('.inc_shops_search1 input[name=adviser]:checked');
					}
					for (let i = 0; i < elements.length; i++) {
						let elVal = elements[i].nextElementSibling.textContent;
						arr.push(elVal);
					}
					paramVlaue = arr.join(' | ');
				}
				if (paramVlaue != '' && paramVlaue != '選択してください') {
					$('.paramsList').append('<span class="paramsList-item">' + paramName + '：' + paramVlaue);
				}
			});
			if ($('.paramsList').html() === '') {
				$('.shops-searchBox-head').text('条件から検索');
			}
		}
	};

	// ＜店舗検索：追加検索フォーム＞ submit処理（メインフォームとvalueを同期）／clear処理（同期なし）
	const searchAdditionForm = () => {
		$('.js-addition-submit').on('click', () => {
			$('.inc_shops_search1 .mod-input[name=keyword]').val($('.shops-search-addition .mod-input').val());
			$('.inc_shops_search2 .mod-input[name=keyword]').val($('.shops-search-addition .mod-input').val());
			$('.inc_shops_search1 .shops-search-pref .mod-select select').val($('.shops-search-addition .mod-select select').val());
			$('.inc_shops_search2 .shops-search-pref .mod-select select').val($('.shops-search-addition .mod-select select').val());
			searchSubmit($('.inc_shops_search1 form'));
		});
		$('.js-addition-clear').on('click', () => {
			$('.shops-search-addition .mod-input').val('');
			$('.shops-search-addition .mod-select select').val('');
		});
	};

	// ＜店舗検索：都道府県＞近隣エリアリンクリスト
	const prefectureNearAreaList = () => {
		let thisPref = NSKW.va.pathname.split('/')[2];
		let thisCls = $('.js-nearPrefAreaList').find(`li[data-target="${thisPref}"]`).attr('class');

		$('.js-nearPrefAreaList').find('li').each((idx, ele) => {
			if ($(ele).hasClass(thisCls) && $(ele).attr('data-target') !== thisPref) {
				$(ele).removeClass('di_none');
			}
		});
	};

	// ＜スリープマスターエキスパート店舗検索＞絞り込み条件を表示
	const searchNarrowDownSME = () => {
		let paramVal = $('.prefectureList-item[href="' + NSKW.va.pathname.replace(/zipcode\.html/, '') +'"]').text();
		$('.paramsList').append('<span class="paramsList-item">都道府県：' + paramVal);
		$('.paramsList').append('<span class="paramsList-item">資格・アドバイザー：スリープマスターエキスパート');
	};

	// ＜店舗詳細＞店舗データ取得
	const getJSONShopDetail = (_shopID) => {
		return $.getJSON(`/ajax/shops/brands/${_shopID}.json`);
	};

	// ＜店舗詳細＞取り扱いブランド描画
	const setShopDetailBrands = (_shopID) => {
		getJSONShopDetail(_shopID).then((data) => {
			if (data.rt_bn_shops_detail.length) {
				if (data.rt_bn_shops_detail[0].cf_s_handled_brands.length) {
					let brandList = data.rt_bn_shops_detail[0].cf_s_handled_brands;
					let HTML = '';
					for (let i = 0; i < brandList.length; i++) {
						if (brandList[i].cf_pb_status === '1') {
							HTML += `<span class="shops-detail-brand-inner"><span>${brandList[i].cf_pb_name_d}</span></span>`;
						}
					}
					if (HTML) {
						$('.shops-detail-brand').append(HTML);
					} else {
						$('.js-brandWrap').remove();
					}
				} else {
					$('.js-brandWrap').remove();
				}
			} else {
				$('.js-brandWrap').remove();
			}
		});
	};

	// ＜店舗詳細＞地図表示
	const setMap = () => {
		if (!$('.vp_lat')[0] && !$('.vp_lon')[0]) {
			$('#map-canvas').addClass('di_none');
		} else {
			let lat = $('.vp_lat').text(); lat = Number(lat);
			let lng = $('.vp_lon').text(); lng = Number(lng);
			let mapLatLng = new google.maps.LatLng({ lat: lat, lng: lng });
			let canvas = document.getElementById('map-canvas');
			let map = new google.maps.Map(canvas, {
				center: mapLatLng,
				zoom: 15
			});
			let marker = new google.maps.Marker({
				position: mapLatLng,
				map: map
			});

			let infoWindow = new google.maps.InfoWindow({
				content: $('.rt_cf_s_name_d').text()
			});
			infoWindow.open(marker.getMap(), marker);

			marker.addListener('click', () => {
				infoWindow.open(marker.getMap(), marker);
			});
		}
	};

	// ＜店舗詳細＞店舗画像カルーセル
	const setShopDetailCarousel = () => {
		$('.shops-detail-intro-images .owl-carousel').owlCarousel({
			items: 1,
			margin: 0,
			nav: true,
			loop: true,
			smartSpeed: 500,
			navText: navText
		});
	};

	// ＜共通＞おすすめ店舗カルーセル
	const setRecommendCarousel = () => {
		$('.shops-recommend-slider').owlCarousel({
			margin: 30,
			nav: true,
			loop: false,
			smartSpeed: 500,
			navText: navText,
			responsive: {
				640: {
					items: 4
				},
				320: {
					items: 1,
					stagePadding: 50
				}
			}
		});
	};

	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	const removeBlockIfListEmpty = () => {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each((idx, val) => {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};

	/* ---------------------------------------------- functions ---------------------------------------------- */

	if (!shopID) { // 販売店検索
		let url2;
		if ($('.inc_shops_search1').length > 0) {
			if (site === 'chain') {
				url2 = location.pathname.split('/')[4]; // 西川チェーン
			} else {
				url2 = location.pathname.split('/')[2]; // 通常の販売店
			}
		} else if (site === 'sme') {
			url2 = location.pathname.split('/')[2]; // スリープマスターエキスパート
		}

		if (site !== 'sme') {
			searchSelectPref(url2);
			searchSetTip();
			searchSetBrands();
			searchClear();
			searchNarrowDown();
			searchAdditionForm();

			$('.js-search-submit').on('click', (e) => {
				searchSubmit($(e.currentTarget).parents('form'));
			});
			$('.shops-search input[name="keyword"]').each((idx, ele) => {
				$(ele).on('keydown', (e) => {
					if (e.keyCode === 13) {
						searchSubmit($(ele).parents('form'));
					}
				});
			});

			// 都道府県：近隣エリア
			if (location.pathname.split('/')[2] !== 'search.html') {
				prefectureNearAreaList();
			} else {
				$('.shops-nearPrefArea').remove();
			}
		} else {
			searchNarrowDownSME();
		}
		searchResultSort(url2);

	} else { // 販売店詳細
		setShopDetailBrands(shopID);
		// setMap(); // 廃止⇒リンクに変更
		setShopDetailCarousel();

		// QRコード
		$('.shops-detail-qr img').attr(
			'src',
			'//chart.apis.google.com/chart?cht=qr&chs=130x130&chl=' + location.href
		);
		// 店舗画像/説明文がどちらも空の場合blockを削除
		if ($('.shops-detail-intro').find('div').length === 0) {
			$('.shops-detail-intro').parents('.rt_bn_shops_detail').remove();
		}
		// 店舗詳細ページ項目チェック・中身が空なら非表示
		if ($('.js-blankRemoveWrap').length) {
			const itemArea = $('.js-blankRemoveWrap');
			for (let i = 0; i < itemArea.length; i++) {
				if (!(itemArea.eq(i).find('span').length)) {
					itemArea.eq(i).addClass('di_none');
				}
			}
		}

		// チェーンサイトの場合 要素が空なら削除
		if (site === 'chain') {
			// 店舗からのご挨拶
			if (!$('.c-shopInformation__wrap').find('div').length) {
				$('.c-shopInformation').remove();
			}
			// お店のオススメ
			if (!$('.c-shopRecommend__items').find('li').length &&
				!$('.c-shopRecommendBanner__items').find('li').length) {
				$('.c-shopRecommend').remove();
			}
		}
	}

	// 共通
	setRecommendCarousel();
	removeBlockIfListEmpty();

})(window.jQuery, window.NSKW, window.cssua);
